import { Component, OnInit, Input, AfterViewInit, ViewChild, ElementRef, ViewEncapsulation, ChangeDetectorRef } from '@angular/core';
import { InventoryService } from '../../services/inventory.service';
import { PurchasingService } from '../../services/purchasing.service';
import { OrdersService } from '../../services/orders.service';
import { OmsService } from '../../services/oms.service';
import { GlobalSearchService } from '../../services/globalsearchservice.service';
import { FormBuilder, FormControl, FormGroup, Validators, UntypedFormControl } from '@angular/forms';
import { NgbModal, ModalDismissReasons } from '@ng-bootstrap/ng-bootstrap';
import { ActivatedRoute, Router } from '@angular/router';
import { trigger, state, style, transition, animate } from '@angular/animations';
import { Location } from '@angular/common'
import { PrintService } from '../../services/print.service'
import { UsersService } from 'app/services/users.service';
import { MatTableDataSource } from '@angular/material/table';
import { Observable } from 'rxjs';
import { MatPaginator } from '@angular/material/paginator';

@Component({
	selector: 'app-warehouse-stock-counts',
	templateUrl: './warehouse-stock-counts.component.html',
	styleUrls: ['./warehouse-stock-counts.component.scss'],
	animations: [
		trigger('flipState', [
			  state('active', style({
				  transform: 'rotate3d(0, 1, 0, 179deg)',
			  })),
			  state('inactive', style({
				  transform: 'rotateY(0)'
			  })),
			  state('orderlookup', style({
				  transform: 'rotateY(179deg)'
			  })),
			  transition('active => inactive', animate('500ms ease-out')),
			  transition('inactive => active', animate('500ms ease-in')),
			  transition('inactive => orderlookup', animate('500ms ease-out')),
			  transition('orderlookup => inactive', animate('500ms ease-in')),
		  ]),
	]
})
export class WarehouseStockCountsComponent implements OnInit {
	today = new Date();
	@ViewChild('count_table') printtable: ElementRef;
	color: any = 'blue';

	location: any = '';
	locations: any = [];
	suppliers: any = false;
	user: any = [];

	sheetForm: FormGroup;
	vendor_selected: any = false;
	sending = false;
	exporting = false;
	// counting_items: any =false;
	fetching = false;
	nil = new FormControl(false);
	flip = 'inactive';
	filename = 'StockCounts';
	stockCountsLink: any = false;
	config: any = false;

	isPosUser: any = false;
	savingCounts: any = false;
	counting_items:any = MatTableDataSource<any>;
	@ViewChild('paginatorBottom', {static: true}) paginator!: MatPaginator;
	dataObs: Observable < any > ;
	items_per_page = [50,100,250,500];
	pagesizedefault = 100;

	limit_load: any = false;

	@ViewChild(MatPaginator) set matPaginator(mp: MatPaginator) {
		this.paginator = mp;
		this.setDataSourceAttributes();
	}

	setDataSourceAttributes() {
		this.counting_items.paginator = this.paginator;
	}

	constructor(private cd: ChangeDetectorRef, private usersService: UsersService, public printService: PrintService, public lLoaction: Location, private fb: FormBuilder,private route: ActivatedRoute, public router: Router, private modalService: NgbModal, private omsService: OmsService, private globalSearchService: GlobalSearchService, private inventoryService: InventoryService, public ordersService: OrdersService, public purchasingService: PurchasingService) {

		this.color = this.globalSearchService.getColor();

		this.usersService.isPosUser().subscribe((isPOS: any) => {
			this.isPosUser = isPOS;
			this.limit_load = true;
			isPOS ? this.limitLocations() : ''
		})

		this.globalSearchService.user.subscribe((u: any) => {
			this.user = u;
			this.location = u.user.defaultlocation.loccode
		});
		this.globalSearchService.configsubscription.subscribe(r => {
			this.config =  r;
		})
	
	}

	ngOnInit(): void {

		this.globalSearchService.locations.subscribe(async (results: any) => {
			this.locations = results;
			if(results.length){
				this.limitLocations();
			}
		});

		this.purchasingService.getSuppliers('').subscribe(async (results: any) => {
			this.suppliers = results;
			if(!this.limit_load){
				this.initialLoad()
			}
		})

	}

	initialLoad(){
		this.sheetForm = this.fb.group({
			keywords: [''],
			location: [this.locations[0].loccode, Validators.required],
			vendor: [this.vendor_selected, Validators.required],
			category: [''],
			lineid: [''],
			stockid: [''],
		});


		this.inventoryService.getCurrentCounts(this.sheetForm.value).subscribe(r  => {
			this.fetching = false;
			if(r.success) {
				this.setPagination(r.items)
			} else {
				this.globalSearchService.showNotification(r.message, 'danger', 'bottom', 'right');
			}
		})
	}

	limitLocations(){
		if(this.isPosUser && this.locations.length){
			this.locations = this.locations.filter((loc)=>loc.loccode == this.user.user.defaultlocation.loccode)
			this.initialLoad();
		}
	}


	resetSheets(event: any) {
		if(event) {
			this.counting_items = false;
			this.fetching = false;
			this.flip = 'inactive';
		}
	}

	pdfLink() {
		return this.inventoryService.printCountSheets(this.sheetForm.value)
	}

	exportXls() {
		this.exporting = true;
		const encoded: string = this.globalSearchService.base64encode(this.printtable.nativeElement.innerHTML);
		const data = {
			content: encoded,
			filename: this.filename,
		}

		this.printService.xls(data).subscribe((result: any) => {
			this.globalSearchService.downloadXls(result.content, data.filename);
			this.exporting = false;
		});
	}

	keywordItemSearch() {

	}

	keywordSearch() {

	}

	selectVendor(supplier: any) {
		const supp = supplier == '' ? '' : supplier.supplierid;
		this.vendor_selected = supp;
		this.sheetForm.get('vendor').setValue(supp);
	}

	selectCategory(value: any) {
		const cat = value == '' ? '' : value.categoryid;
		this.sheetForm.get('category').setValue(cat);
	}

	selectProductLine(value: any) {
		const line = value == '' ? '' : value.line_field;
		this.sheetForm.get('lineid').setValue(line);
	}

	createLoadSheets() {
		this.fetching = true;
		
		var data = this.sheetForm.value;
		data.user = this.user.user.userid;
		data.ispos = this.isPosUser;

		this.inventoryService.createLoadSheets(data).subscribe( (r:any) => {
			this.fetching = false;
			if(r.success) {
				this.setPagination(r.items);
			} else {
				this.globalSearchService.showNotification(r.message, 'danger', 'bottom', 'right');
			}
		});
	}

	setQty(event: any, item: any) {
		let val = parseFloat(event.target.value);
		if(isNaN(val)) {
			val = 0;
		}
		item.counted = val;
	}

	saveCounts() {
		if(this.savingCounts){
			this.savingCounts.unsubscribe();
		}
		this.savingCounts = this.inventoryService.saveCounts(this.counting_items).subscribe(r => {
			this.savingCounts = false;
			if(r.success) {
				this.globalSearchService.showNotification(r.msg, 'success', 'bottom', 'left');
			}
		})
	}



	identify(index, item) {
		return item.line;
	 }

	toggleFlip() {
		this.flip = (this.flip =='inactive') ? 'active' : 'inactive';
		if(this.flip == 'active') {

		}
	}

	back(): void {
		this.lLoaction.back()
	}


	setPagination(tableData) {
		this.counting_items = new MatTableDataSource < any > (tableData);
		this.cd.detectChanges();
		this.counting_items.paginator = this.paginator;
		this.dataObs = this.counting_items.connect();
	}

}
